import DiamondIcon from "@mui/icons-material/Diamond";
import Badge, { badgeClasses } from "@mui/material/Badge";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { severities } from "../../../stack/environment/icons/iconExport";
import { IntegrationsMapping } from "../../../stack/integrations/IntegrationsMapping";

function calculateTopHalfBadgePositions(numBadges, radius, badge) {
  const positions = [];
  let circleDivided = 1;

  if (numBadges === 1) {
    return [{ x: 36, y: 46 }];
  }
  if (numBadges === 2) {
    circleDivided = 1 / 3;
  }
  if (numBadges > 2 && numBadges < 4) {
    circleDivided = 2 / 3;
  }

  const angleStep = (circleDivided * Math.PI) / (numBadges - 1); // Divide the bottom half circle into numBadges parts
  for (let i = 0; i < numBadges; i++) {
    const angle = angleStep * i;
    const x = radius * Math.cos(angle) + 3;
    const y = radius * Math.sin(angle) + 9;
    positions.push({ x, y });
  }
  return positions;
}
const IConRender = (iconName, size) => {
  const colors = useColors();
  if (iconName === "asset") {
    return (
      <DiamondIcon
        sx={{ color: colors.primary_main }}
        style={{
          paddingTop: "1px",
          height: size,
          width: size,
        }}
      />
    );
  }
  return (
    <Box display={"flex"} alignItems={"center"}>
      <SvgToIcon IconLogo={IntegrationsMapping[iconName]?.logo} width={size} />
    </Box>
  );
};

export default function BadgeOverlap({
  items,
  impact,
  size = "standard",
  hidden = false,
  location = "bl",
  children,
}) {
  const numBadges = items ? items.length : 0;
  const radius = 50; // Radius of the circle
  const IconHighImpact = severities.SeverityBlackIcon;

  const sizes = {
    standard: "20px",
    big: "26px",
    small: "14px",
  };
  const iconSizes = {
    standard: "16px",
    big: "28px",
    small: "10px",
  };
  const positions = calculateTopHalfBadgePositions(numBadges, radius);
  const colors = useColors();

  const styleLocation = {
    bl: (x, y) => ({
      bottom: `${50 - y}%`,
      left: `${50 - x}%`,
    }),
    mr: (x, y) => ({
      right: `${40 - x}%`,
      bottom: `${100 - y}%`,
    }),
  };
  if (!hidden) {
    return (
      <Stack spacing={3} direction="row">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {children}
          {positions.map(({ x, y }, index) => {
            if (index < 2 || (index === 2 && numBadges === 3))
              return (
                <Badge
                  badgeContent={IConRender(items[index], iconSizes[size])}
                  overlap="circular"
                  sx={{
                    [`& .${badgeClasses.standard}`]: {
                      width: sizes[size],
                      height: sizes[size],
                      borderRadius: "50%",
                      minHeight: sizes[size],
                      maxHeight: sizes[size],
                      minWidth: sizes[size],
                      maxWidth: sizes[size],
                      backgroundColor:
                        items[0] === "asset"
                          ? colors.grey_50
                          : colors.common_white,
                      border:
                        items[0] === "asset"
                          ? "1px solid " + colors.error_darker
                          : "1px solid " + colors.grey_500,
                    },

                    position: "absolute",
                    ...styleLocation[location](x, y),
                  }}
                  key={index}
                />
              );
            else if (index === 2)
              return (
                <Badge
                  badgeContent={
                    <Box display={"flex"} alignContent={"center"}>
                      +{numBadges - 2}
                    </Box>
                  }
                  overlap="circular"
                  sx={{
                    [`& .${badgeClasses.standard}`]: {
                      width: sizes.standard,
                      height: sizes.standard,
                      borderRadius: "50%",
                      maxWidth: sizes.standard,
                      color: "black",
                      minWidth: sizes.standard,
                      backgroundColor: colors.common_white,
                      border: "1px solid " + colors.grey_500,
                      fontSize: "9px",
                    },

                    position: "absolute",
                    bottom: `${50 - y}%`,
                    left: `${50 - x}%`,
                  }}
                  key={index}
                />
              );
          })}
        </div>
      </Stack>
    );
  } else return <>{children}</>;
}
